import React, {memo} from 'react';
import './video-react.css';

import { Player, BigPlayButton } from 'video-react';

import { Grid, Box } from '@material-ui/core';

interface IProps {
    src: String;
    refFn: (ref: any) => void;
}


const Video = ({ src, refFn }: IProps) => {
    return (
        <Grid item xs={12}>
            <Box display="flex" justifyContent="center">
                <div>
                    <Player ref={refFn} fluid={false} width={400} height={300} src={src}>
                        <BigPlayButton position='center' />
                    </Player>
                </div>
            </Box>
        </Grid>
    );
};

export default memo(Video);
